define('lib/backbone/Backbone.PodioCachedCollection',['require','lib/backbone/Backbone.PodioCollection'],function(require) {

  var CollectionPodioBase = require('lib/backbone/Backbone.PodioCollection');

  return CollectionPodioBase.extend({

    initialize: function() {
      this.cache = {};
      this.cacheKey = '';
    },

    initCache : function(cacheKey) {
      if(cacheKey) {
        this.cacheKey = cacheKey;
      }

      this.clearCache();
    },

    setCacheKey : function(cacheKey) {
      this.cacheKey = cacheKey;
    },

    clearCache : function() {
      this.cache = {};
      this.trigger('cacheCleared');
    },

    getCacheEntry: function(key) {
      var cacheEntry = this.cache[this.cacheKey];
      return cacheEntry;
    },

    setCacheEntry: function(object) {
      this.cache[this.cacheKey] = object;
    },

    fetch: function(options){
      options = options || {};

      var self = this;
      var success = options.success;

      var cacheEntry = this.cache[this.cacheKey];
      if(cacheEntry) {
        this.reset(cacheEntry);
        if(success){
          options.success(this, "");
        }
      } else {

        options.success = function(collection, result){
          self.cache[self.cacheKey] = collection.toJSON();

          if(success){
            success(collection, result);
          }
        };

        // Call super method
        return this._super(options);
      }
    }

  });

});



